<footer>
    <div class="row">
        <div class="col-lg-3 logo">
            <a href="index.html">
               <img src="assets/images/logoB2BPie.png" class="logoPie" alt="Logo FACeB2B">
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-4">
          <span  class="h4" translate>
               pub.footer.faceb2b
          </span>
          <ul>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracioninvoice" target="_blank" translate>
                      pub.footer.wsIntegration
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracioninvoicingservice" target="_blank" translate>
                     pub.footer.wsIntegration2
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/integracionclients" target="_blank" translate>
                      pub.footer.wsIntegration3
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-12 col-lg-3 col-sm-4">
            <span class="h4" translate>
               pub.footer.utilities
            </span>
            <ul>
                <li>
                    <a id="Onboarding" class="noEnResponsive" translate>pub.footer.UseGuide</a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/manualusuario" target="_blank" translate>
                      pub.footer.techRequirements
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/PAe/FACeB2B/faqs" target="_blank" translate>
                     pub.footer.techRequirements2
                    </a>
                </li>
                <li>
                    <a href="https://ssweb.seap.minhap.es/ayuda/consulta/FACEB2B" target="_blank" translate>
                      pub.footer.support
                    </a>
                </li>
              <li>
                <a routerLink="accesibilidad" routerLinkActive="active" translate>
                  pub.footer.accesibility
                </a>
              </li>
            </ul>
        </div>
        <div class="col-12 col-lg-3 col-sm-4">
            <span class="h4" translate>
                pub.footer.links
            </span>
            <ul>
                <li>
                    <a href="http://dire.gob.es" target="_blank" translate>
                       pub.footer.dire
                    </a>
                </li><li>
                    <a href="http://face.gob.es" target="_blank" translate>
                        pub.footer.face
                    </a>
                </li>
                <li>
                    <a href="http://administracionelectronica.gob.es/"  target="_blank" translate>
                        pub.footer.pae
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="subFooter" translate>
      pub.footer.subFooter
    </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/app-manager/mng-footer/mng-footer.component.html